export const authRoles = {
    SA: ['SA'], // Only Super Admin has access
    ADMIN: ['SA', 'ADMIN'], // Only SA & Admin has access
    DRIVER: ['DRIVER'], // Only SA & Admin & Editor has access
    GUEST: ['SA', 'ADMIN', 'DRIVER', 'GUEST', 'SUB-OFFICE'], // Everyone has access
     SUBOFFICE: ['SUB-OFFICE'], // ONLY SUBOFFICE has access
}
